import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom';

// Pages
import LandingPage from '../containers/LandingPage';

export default class UnauthorizedLayout extends Component {
    render() {
        return (
            <div className="unauthorized-layout">
                <Switch>
                    <Route path="/login" component={LandingPage} />
                    <Redirect to="/login" />
                </Switch>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Layouts/UnauthorizedLayout.js